import { Component} from '@angular/core';
import { BpgCommonService } from '../services/bpg-common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './bpg-footer.component.html',
  styleUrls: ['./bpg-footer.component.css']
})
export class BpgFooterComponent{
  loginError: boolean;
  constructor(private readonly bpgCommonService: BpgCommonService) { 
    this.bpgCommonService.loginError.subscribe(value =>{
      this.loginError = value;
    })
  }

}
